import React, { FC } from 'react';
import Text from '@components/common/text';
import ApplyTab from './tab';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './applyStatus.module.scss';
const cx = classnames.bind(styles);

const ApplyStatus: FC = () => {
  return (
    <>
      <div className={cx('wrap')}>
        <Text fontStyle={FontStyle.H4_B} styles={{ padding: '1px 0' }}>
          북마크
        </Text>
        <ApplyTab />
      </div>
    </>
  );
};

export default ApplyStatus;
